{
  "tabs": {
    "chat": "च्याट",
    "reminders": "स्मरणहरू",
    "calendar": "क्यालेन्डर",
    "settings": "सेटिङहरू"
  },
  "common": {
    "cancel": "रद्द गर्नुहोस्",
    "save": "सेभ गर्नुहोस्",
    "confirm": "पुष्टि गर्नुहोस्",
    "delete": "मेटाउनुहोस्",
    "back": "पछाडि",
    "close": "बन्द गर्नुहोस्",
    "edit": "सम्पादन गर्नुहोस्",
    "search": "खोज्नुहोस्",
    "all": "सबै",
    "loading": "लोड हुँदैछ...",
    "error": "केहि समस्या भयो",
    "notFound": "फेला परेन",
    "tryAgain": "कृपया फेरि प्रयास गर्नुहोस्",
    "retry": "फेरि प्रयास",
    "undo": "पूर्ववत् गर्नुहोस्",
    "pullToRefresh": "ताजा गर्न तान्नुहोस्",
    "justNow": "अहिले मात्र"
  },
  "auth": {
    "welcome": "FishMemory मा स्वागत छ",
    "tagline": "तपाईंको WhatsApp स्मरण सहायक, अब तपाईंको झोला भित्र।",
    "subtitle": "तपाईंको WhatsApp स्मरण सहायक, अब तपाईंको झोला भित्र।",
    "phoneLabel": "तपाईंको WhatsApp नम्बर",
    "phoneHint": "हामी WhatsApp मार्फत प्रमाणीकरण कोड पठाउनेछौं",
    "invalidPhone": "कृपया मान्य फोन नम्बर प्रविष्ट गर्नुहोस्",
    "continue": "जारी राख्नुहोस्",
    "enterPhone": "तपाईंको WhatsApp नम्बर प्रविष्ट गर्नुहोस्",
    "phonePlaceholder": "फोन नम्बर",
    "sendCode": "कोड पठाउनुहोस्",
    "verifyTitle": "तपाईंको नम्बर प्रमाणित गर्नुहोस्",
    "otpSentTo": "६-अङ्क कोड {{phone}} मा WhatsApp मार्फत पठाइयो",
    "enterFullCode": "कृपया सबै ६ अङ्कहरू प्रविष्ट गर्नुहोस्",
    "invalidOtp": "अवैध कोड। कृपया फेरि प्रयास गर्नुहोस्।",
    "otpFailed": "कोड पठाउन असफल। फेरि प्रयास गर्नुहोस्।",
    "otpResent": "कोड पुनः पठाइयो",
    "resendIn": "{{seconds}} सेकेन्डमा पुनः पठाउनुहोस्",
    "resendCode": "कोड पुनः पठाउनुहोस्",
    "enterOtp": "तपाईंको WhatsApp मा पठाइएको कोड प्रविष्ट गर्नुहोस्",
    "verify": "प्रमाणित गर्नुहोस्",
    "resend": "कोड पुनः पठाउनुहोस्",
    "wrongNumber": "गलत नम्बर?",
    "backToPhone": "फोनमा फर्कनुहोस्",
    "editPhone": "फोन नम्बर सम्पादन गर्नुहोस्",
    "error": "त्रुटि",
    "setupTitle": "सेटअप गरौं",
    "setupSubtitle": "तपाईंले पछि सेटिङहरूमा परिवर्तन गर्न सक्नुहुन्छ",
    "namePlaceholder": "तपाईंको नाम",
    "letsGo": "सेटअप पूरा गर्नुहोस्",
    "skipForNow": "अहिले छोड्नुहोस्"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "सन्देश टाइप गर्नुहोस्...",
    "inputPlaceholder": "सन्देश टाइप गर्नुहोस्...",
    "typing": "FishMemory टाइप गर्दैछ...",
    "online": "अनलाइन",
    "connecting": "जोड्दै...",
    "reconnecting": "फेरि जोड्दै...",
    "offline": "अफलाइन",
    "empty": "संवाद सुरु गर्नुहोस्",
    "emptyHint": "स्मरणहरू बनाउनुहोस्, तालिका जाँच गर्नुहोस्, वा सहयोग माग्नुहोस्।",
    "emptyAction": "नमूना स्मरण पठाउनुहोस्",
    "actions": "च्याट क्रियाहरू",
    "keep": "सन्देश राख्नुहोस्",
    "clearTitle": "च्याट खाली गर्नुहोस्",
    "clearConfirm": "यस उपकरणबाट सबै सन्देशहरू मेटाउन चाहनुहुन्छ? यो फिर्ता गर्न सकिँदैन।",
    "clear": "च्याट खाली गर्नुहोस्",
    "optionSelected": "छानिएको: {{label}}",
    "sendingSelection": "पठाउँदै...",
    "connectionLost": "फेरि जोड्दै..."
  },
  "reminders": {
    "title": "मेरो स्मरणहरू",
    "active": "सक्रिय",
    "today": "आज",
    "thisWeek": "यो हप्ता",
    "history": "इतिहास",
    "items": "वस्तुहरू",
    "emptyTitle": "अझै स्मरण छैन",
    "emptySubtitle": "च्याटबाट एउटा बनाउनुहोस् र यहाँ देखिनेछ।",
    "emptyAction": "च्याट खोल्नुहोस्",
    "filterActive": "सक्रिय",
    "filterToday": "आज",
    "filterWeek": "यो हप्ता",
    "filterHistory": "इतिहास",
    "emptyState": "अझै स्मरण छैन। कुराकानी सुरु गर्नुहोस्!",
    "swipeDone": "सम्पन्न",
    "swipeSnooze": "स्नूज",
    "swipeDelete": "मेटाउनुहोस्",
    "search": "स्मरण खोज्नुहोस्...",
    "upcoming": "आउँदैछ",
    "completed": "सम्पन्न",
    "overdue": "म्याद गुज्रिएको",
    "tomorrow": "भोलि",
    "synced": "समक्रमित {{value}}",
    "swipeHint": "थप क्रियाहरूका लागि स्मरण स्वाइप गर्नुहोस्",
    "noResults": "तपाईंको खोजासँग मेल खाने स्मरण छैन",
    "noResultsHint": "अर्को शब्द प्रयोग गर्नुहोस् वा खोजा खाली गर्नुहोस्",
    "deleteAllFailed": "सबै स्मरणहरू मेटाउन असफल"
  },
  "calendar": {
    "title": "क्यालेन्डर",
    "today": "आज",
    "tomorrow": "भोलि",
    "completed": "सम्पन्न",
    "noEvents": "कुनै कार्यक्रम छैन",
    "noEventsSubtitle": "स्मरण र क्यालेन्डर कार्यक्रम हेर्न मिति छान्नुहोस्।",
    "googleEvent": "Google क्यालेन्डर",
    "legendActive": "सक्रिय",
    "legendRecurring": "पुनरावृत्ति",
    "legendDone": "सम्पन्न",
    "legendGoogle": "Google",
    "previousMonth": "अघिल्लो महिना",
    "nextMonth": "अर्को महिना",
    "previousYear": "अघिल्लो वर्ष",
    "nextYear": "अर्को वर्ष",
    "goToToday": "आजमा जानुहोस्",
    "all": "सबै",
    "active": "सक्रिय",
    "done": "सम्पन्न",
    "paused": "बिराम"
  },
  "settings": {
    "title": "सेटिङहरू",
    "profile": "प्रोफाइल",
    "name": "प्रदर्शन नाम",
    "enterName": "तपाईंको नाम प्रविष्ट गर्नुहोस्",
    "language": "भाषा",
    "uiLanguage": "एप भाषा",
    "uiLanguageHelp": "यस उपकरणमा मात्र एप UI, क्यालेन्डर लेबल र लेआउट दिशा परिवर्तन गर्दछ।",
    "serverLanguage": "च्याट भाषा",
    "serverLanguageHelp": "तपाईंको खाताको लागि सर्भर जवाफ र स्मरण सन्देशको भाषा परिवर्तन गर्दछ।",
    "timezone": "समय क्षेत्र",
    "currentTimezone": "हालको समय क्षेत्र",
    "timezoneHelp": "सबै स्मरण समयहरू यस समय क्षेत्र अनुसार देखाइन्छ।",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "समय क्षेत्र सेभ गर्नुहोस्",
    "timezoneSaved": "समय क्षेत्र अपडेट भयो",
    "detect": "पत्ता लगाउनुहोस्",
    "detectFailed": "समय क्षेत्र पत्ता लगाउन सकेन",
    "autoDetect": "GPS बाट स्वचालित पत्ता लगाउनुहोस्",
    "notifications": "सूचनाहरू",
    "notificationsHelp": "फोलो-अप स्मरणहरूले स्मरण पुर्‍याएपछि दोहोरिने सूचनाहरू नियन्त्रण गर्छ। उपकरण स्तरको सूचनाको अनुमति तपाईंको फोन सेटिङमा व्यवस्थापन हुन्छ।",
    "pushEnabled": "पुष सूचनाहरू",
    "autoDoneOnFire": "स्मरण बज्दा स्वचालित सम्पन्न मार्क",
    "autoDoneOnFireDesc": "अफ हुँदा, स्मरणहरू तपाईंले सम्पन्न मार्क नगरेसम्म सक्रिय रहन्छ।",
    "googleCalendar": "Google क्यालेन्डर",
    "google": "Google क्यालेन्डर",
    "googleConnected": "जोडिएको",
    "googleDisconnected": "जोडिएको छैन",
    "googleConnectedHelp": "नयाँ स्मरणहरू स्वचालित रूपमा तपाईंको क्यालेन्डरसँग समक्रमित गर्न सकिन्छ।",
    "googleDisconnectedHelp": "स्मरण र कार्यक्रमहरू मिलाउन Google क्यालेन्डर जोड्नुहोस्।",
    "googleConnectFailed": "Google क्यालेन्डर जोड्न असफल",
    "connected": "जोडिएको",
    "disconnected": "जोडिएको छैन",
    "connect": "जोड्नुहोस्",
    "disconnect": "जोड तोड्नुहोस्",
    "autoSync": "नयाँ स्मरणहरू स्वचालित समक्रमण",
    "autosync": "नयाँ स्मरणहरू स्वचालित समक्रमण",
    "subscription": "सदस्यता",
    "trialUsed": "परीक्षण: {{used}}/{{total}} प्रयोग भयो",
    "trialStatus": "परीक्षण उपलब्ध",
    "activeStatus": "सक्रिय सदस्यता",
    "expiredStatus": "सदस्यता समाप्त",
    "unsubscribedStatus": "सदस्यता छैन",
    "about": "बारेमा",
    "version": "संस्करण",
    "logout": "लगआउट",
    "logoutTitle": "लगआउट",
    "logoutConfirm": "के तपाईं साँच्चै लगआउट गर्न चाहनुहुन्छ?",
    "noName": "नाम सेट गरिएको छैन",
    "serverConnection": "सर्भर जडान",
    "serverUrl": "सर्भर URL",
    "serverEdit": "सम्पादन गर्नुहोस्",
    "saveReconnect": "सेभ गरी पुनः जडान गर्नुहोस्",
    "resetDefault": "पूर्वनिर्धारितमा फिर्ता जानुहोस्",
    "invalidServerUrlTitle": "अवैध सर्भर URL",
    "invalidServerUrlMessage": "कृपया मान्य http वा https सर्भर URL प्रविष्ट गर्नुहोस्, जस्तै https://example.com",
    "uiLanguageChangeFailed": "एप भाषा परिवर्तन गर्न असफल। कृपया फेरि प्रयास गर्नुहोस्।",
    "serverLanguageChangeFailed": "च्याट भाषा परिवर्तन गर्न असफल। कृपया फेरि प्रयास गर्नुहोस्।",
    "timezoneChangeFailed": "समय क्षेत्र परिवर्तन गर्न असफल। कृपया फेरि प्रयास गर्नुहोस्।",
    "autoSyncChangeFailed": "स्वचालित समक्रमण अपडेट गर्न असफल। कृपया फेरि प्रयास गर्नुहोस्।",
    "nameChangeFailed": "प्रदर्शन नाम अपडेट गर्न असफल। कृपया फेरि प्रयास गर्नुहोस्।",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "स्मरण विवरण",
    "editTime": "समय सम्पादन गर्नुहोस्",
    "rename": "नाम परिवर्तन गर्नुहोस्",
    "snooze": "स्नूज गर्नुहोस्",
    "snooze15": "१५ मिनेट स्नूज गर्नुहोस्",
    "pause": "बिराम दिनुहोस्",
    "pauseReminder": "स्मरणलाई बिराम दिनुहोस्",
    "resume": "पुनः सुरु गर्नुहोस्",
    "resumeReminder": "स्मरण पुनः सुरु गर्नुहोस्",
    "skip": "अर्को छोड्नुहोस्",
    "skipOccurrence": "यो घटना छोड्नुहोस्",
    "syncGoogle": "Google सँग समक्रमण गर्नुहोस्",
    "delete": "मेटाउनुहोस्",
    "deleteTitle": "स्मरण मेटाउनुहोस्",
    "deleteConfirm": "यो स्मरण स्थायी रूपमा मेटाइनेछ।",
    "deleteRecurringTitle": "पुनरावृत्ति स्मरण मेटाउनुहोस्",
    "deleteRecurringMessage": "के तपाईं यो घटना छोड्न चाहनुहुन्छ वा सम्पूर्ण श्रृंखला मेटाउन?",
    "deleteThisOccurrence": "यो घटना छोड्नुहोस्",
    "deleteEntireSeries": "सम्पूर्ण श्रृंखला मेटाउनुहोस्",
    "done": "सम्पन्न",
    "markDone": "सम्पन्न मार्क गर्नुहोस्",
    "undo": "पुनर्स्थापना गर्नुहोस्",
    "undoPrompt": "फेरि सक्रिय चाहिन्छ? अहिले पुनर्स्थापना गर्नुहोस्।",
    "recurring": "पुनरावृत्ति",
    "nextRun": "अर्को चलाउने समय",
    "oneTime": "एक पटक",
    "pending": "प्रतीक्षामा",
    "sent": "पठाइएको",
    "paused": "बिराममा",
    "active": "सक्रिय",
    "snoozed": "स्नूज गरिएको",
    "localTime": "तपाईंको स्थानीय समयमा देखाइएको",
    "recurrence": "पुनरावृत्ति",
    "created": "बनाइएको",
    "tags": "ट्यागहरू",
    "fireCount": "चालु भएको पटक",
    "actions": "क्रियाहरू",
    "none": "कुनै छैन",
    "snoozeFailed": "स्मरण स्नूज गर्न असफल",
    "pauseFailed": "स्मरण बिराम दिन असफल",
    "resumeFailed": "स्मरण पुनः सुरु गर्न असफल",
    "skipFailed": "स्मरण छोड्न असफल",
    "doneFailed": "स्मरणलाई सम्पन्न मार्क गर्न असफल",
    "undoFailed": "स्मरण स्थिति पुनर्स्थापना गर्न असफल",
    "deleteFailed": "स्मरण मेटाउन असफल",
    "rescheduleTitle": "पुनः तालिका बनाउने?",
    "rescheduleMsg": "यो स्मरण म्याद गुज्रिएको छ। के तपाईं यसलाई पुनः तालिका बनाउने चाहनुहुन्छ?",
    "reschedule15": "१५ मिनेटमा",
    "reschedule60": "१ घण्टामा",
    "keepOverdue": "जस्तै छोड्नुहोस्"
  },
  "onboarding": {
    "slide1Title": "FishMemory मा स्वागत छ",
    "slide1Sub": "तपाईंको व्यक्तिगत स्मरण सहायक — WhatsApp द्वारा संचालित र तपाईंको झोलाका लागि बनाइएको।",
    "slide2Title": "सहजै कुराकानी गर्नुहोस्",
    "slide2Sub": "स्मरणहरू त्यही अनुसार टाइप गर्नुहोस्: \"मलाई भोलि ३ बजे आमा लाई फोन गर्न सम्झाउनुहोस्\" — बाँकी हामी हेरौं।",
    "slide3Title": "कुनै कुरा छुट्दैन",
    "slide3Sub": "समयमै सूचनाहरू पाउनुहोस्, ट्यागहरूबाट व्यवस्थित गर्नुहोस्, र सबै महत्वपूर्ण कुरामा अपडेट रहनुहोस्।",
    "getStarted": "सुरु गर्नुहोस्",
    "next": "अर्को",
    "firstReminderTitle": "तपाईंको पहिलो स्मरण बनाउनुहोस्!",
    "firstReminderHint": "यसरी टाइप गरेर प्रयास गर्नुहोस्:",
    "firstReminderExample": "मलाई भोलि बिहान ९ बजे पानी पिउन सम्झाउनुहोस्",
    "gotIt": "बुझें!",
    "notifRationaleTitle": "समयमै रहनुहोस्",
    "notifRationaleBody": "FishMemory ले तपाईंलाई समयमै सम्झाउन सूचनाहरू आवश्यक पर्छ। तपाईंले बनाएको स्मरणहरूको लागि मात्र सूचना प्राप्त गर्नुहुनेछ।",
    "notifRationaleAllow": "सूचनाहरू सक्षम गर्नुहोस्",
    "notifRationaleLater": "सायद पछि",
    "swipeHint": "छिटो क्रियाहरूका लागि दायाँ स्वाइप गर्नुहोस् →",
    "calendarDragHint": "फैलाउन तान्नुहोस् ↕"
  }
}
